import React from 'react';
import BrowserFrame from './BrowserFrame';
import { Truck, MapPin, Calendar, Mic } from 'lucide-react';

const TEAL = '#02857E';

const PostTruckMockup: React.FC<{ className?: string }> = ({ className }) => (
  <BrowserFrame url="app.lanerunner.com/post-truck" className={className}>
    <div className="p-5">
      <div className="rounded-xl border border-gray-200 bg-white p-5">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div
              className="h-8 w-8 rounded-lg inline-flex items-center justify-center"
              style={{ backgroundColor: `${TEAL}15` }}
            >
              <Truck className="h-4 w-4" style={{ color: TEAL }} />
            </div>
            <h4 className="text-sm font-bold text-gray-900">Post Your Truck</h4>
          </div>
          <button
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold text-white"
            style={{ backgroundColor: TEAL }}
          >
            <Mic className="h-3 w-3" /> Voice
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
              Equipment
            </label>
            <div className="mt-1 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-xs font-medium text-gray-900 flex items-center justify-between">
              <span>Dry Van · 53'</span>
              <span className="text-gray-400">▾</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                Origin
              </label>
              <div className="mt-1 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-xs font-medium text-gray-900 flex items-center gap-1.5">
                <MapPin className="h-3 w-3" style={{ color: TEAL }} />
                Kansas City, MO
              </div>
            </div>
            <div>
              <label className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                Destination
              </label>
              <div className="mt-1 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-xs font-medium text-gray-900 flex items-center gap-1.5">
                <MapPin className="h-3 w-3 text-amber-500" />
                Anywhere · NE
              </div>
            </div>
          </div>

          <div>
            <label className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
              Available
            </label>
            <div className="mt-1 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 text-xs font-medium text-gray-900 flex items-center gap-1.5">
              <Calendar className="h-3 w-3" style={{ color: TEAL }} />
              Tue, Jun 16 · 8 AM
            </div>
          </div>

          <button
            className="w-full mt-2 py-2 rounded-lg text-xs font-bold text-white"
            style={{ backgroundColor: TEAL }}
          >
            Post Truck
          </button>
          <div className="text-center text-[10px] text-gray-500">
            Brokers with matching freight get auto-matched
          </div>
        </div>
      </div>
    </div>
  </BrowserFrame>
);

export default PostTruckMockup;
